import { Navigate } from 'react-router-dom';

// Page « Relances factures » fusionnée dans « Tâches ».
export default function RelancesFactures() {
  return <Navigate to="../taches" replace />;
}
